import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import UTTable from 'app/components/UTTable';
import { MobileBreakpoint } from 'constants/deviceSizes';

class AccountDebtTable extends Component {
  constructor(props) {
    super(props);
    this.state = { ...this.getTableWidth() };
    window.addEventListener('resize', this.updateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth);
  }

  getTableWidth = () => ({
    width:
      (window.outerWidth || window.innerWidth) >= MobileBreakpoint
        ? (window.outerWidth || window.innerWidth) * 0.48
        : (window.outerWidth || window.innerWidth) * 0.9
  });

  updateWidth = () => this.setState({ ...this.getTableWidth() });

  render() {
    return (
      <div style={this.props.style}>
        <UTLabel extrabold>{this.props.title}</UTLabel>
        <UTTable
          alignLeft
          width={this.state.width}
          columns={this.props.tableColumns}
          id={this.props.concepts}
          rows={this.props.concepts}
        />
      </div>
    );
  }
}

AccountDebtTable.propTypes = {
  concepts: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  style: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  title: PropTypes.string,
  tableColumns: PropTypes.array // eslint-disable-line react/forbid-prop-types
};

export default AccountDebtTable;
